import { toCurrency } from '@fastre/core/helperFunctions/string'
import { InternalAgentStatement } from '@fastre/core/schemas/agentStatement'
import { format } from 'date-fns'
import { Fragment } from 'react'

export default function AgentStatementRow({
    item,
    children,
}: {
    item: InternalAgentStatement
    children?: React.ReactNode
}) {
    if (item.type == 'debit') {
        return (
            item.type == 'debit' && (
                <tr>
                    <td>{format(item.date, 'dd/MM/yy')}</td>
                    <td>{item.description}</td>
                    <td style={{ textAlign: 'right' }}>{toCurrency(item.amount)}</td>
                    <td></td>
                    {children}
                </tr>
            )
        )
    } else {
        if (item.creditType == 'listingCommission') {
            return (
                <tr>
                    <td>{format(item.date, 'dd/MM/yy')}</td>
                    <td>
                        <b>Agent Commission - {item.listingName}</b>
                        <br />
                        <b>TOTAL (Inc.):</b> {toCurrency(item.totalCommissionAmountIncGst)}
                        {item.conjunctionalAgreements.map(ca => (
                            <Fragment key={ca.name}>
                                <br />
                                <b>Conjunction ({ca.name}):</b> {toCurrency(ca.amount)}
                            </Fragment>
                        ))}
                        <br />
                        <b>AGENT inc. Super:</b> {toCurrency(item.agentCommissionAmountIncSuper)}
                        <br />
                        <b>AGENT PAYMENT:</b> {toCurrency(item.agentCommissionAmountExSuper)}
                    </td>
                    <td></td>
                    <td style={{ textAlign: 'right' }}>{toCurrency(item.amount)}</td>
                    {children}
                </tr>
            )
        } else if (item.creditType == 'conjunctionalAgreement') {
            return (
                <tr>
                    <td>{format(item.date, 'dd/MM/yy')}</td>
                    <td>
                        <b>Referral Commission</b> - {item.listingName}
                        <br />
                        <b>TOTAL (Inc.):</b> {toCurrency(item.amountIncGst)}
                        <br />
                        <b>AGENT inc. Super:</b> {toCurrency(item.agentCommissionAmountIncSuper)}
                        <br />
                        <b>AGENT PAYMENT:</b> {toCurrency(item.agentCommissionAmountExSuper)}
                    </td>
                    <td></td>
                    <td style={{ textAlign: 'right' }}>${toCurrency(item.amount)}</td>
                    {children}
                </tr>
            )
        } else {
            return (
                <tr>
                    <td>{format(item.date, 'dd/MM/yy')}</td>
                    <td>{item.description}</td>
                    <td></td>
                    <td style={{ textAlign: 'right' }}>{toCurrency(item.amount)}</td>
                    {children}
                </tr>
            )
        }
    }
}
